module.exports = __webpack_public_path__ + "img/tag_金分赛事@2x.024e0511.png";